import request from '@/utils/request'


// 查询活动列表
export function listActivity(query) {
  return request({
    url: '/biz/admin/activity/activity/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询活动分页
export function pageActivity(query) {
  return request({
    url: '/biz/admin/activity/activity/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询活动详细
export function getActivity(data) {
  return request({
    url: '/biz/admin/activity/activity/detail',
    method: 'get',
    params: data
  })
}

// 新增活动
export function addActivity(data) {
  return request({
    url: '/biz/admin/activity/activity/add',
    method: 'post',
    data: data
  })
}

// 修改活动
export function updateActivity(data) {
  return request({
    url: '/biz/admin/activity/activity/edit',
    method: 'post',
    data: data
  })
}

// 删除活动
export function delActivity(data) {
  return request({
    url: '/biz/admin/activity/activity/delete',
    method: 'post',
    data: data
  })
}

export function statusActivity(data) {
  return request({
    url: '/biz/admin/activity/activity/status',
    method: 'post',
    data: data
  })
}
